<div class="sales-card">
    <div class="card-header">
      <div class="card-title">
        <strong>Jobs</strong>
      </div>
    </div>
    <!-- Chart Container -->
    <canvas id="jobChart"></canvas>
  </div>
  